import { ChakraStylesConfig } from 'chakra-react-select';

export const solid: ChakraStylesConfig = {
  container: (provided) => ({
    ...provided,
    borderRadius: 4,
    bgColor: 'background.900',
    display: 'flex',
  }),
  control: (provided, { selectProps: { isInvalid } }) => ({
    ...provided,
    border: 0,
    _focus: {
      bgColor: 'secondary.50',
      borderColor: isInvalid ? null : 'secondary.50',
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: 14,
    color: 'text.100',
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: 14,
  }),
  option: (provided) => ({
    ...provided,
    minHeight: 35,
    color: 'text.100',
    fontSize: 14,
    bgColor: 'white',
    marginY: 2,
    _hover: {
      color: 'white',
      bgColor: 'blue.100',
    },
  }),
  menu: (provided) => ({
    ...provided,
    'z-index': 10,
    marginTop: 0,
    display: 'inline-table',
    overflow: 'visible',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
    borderRadius: 4,
    borderColor: 'grey.400',
    minW: 'fit-content',
    bgColor: 'white',
    '::-webkit-scrollbar': {
      width: '4px',
    },
    '::-webkit-scrollbar-thumb': {
      background: 'grey.400',
      borderRadius: '2px',
    },
  }),
  indicatorSeparator: (provided) => ({ ...provided, display: 'none' }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: 0,
    marginRight: 2,
    bgColor: 'transparent',
  }),
};
